const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20with%20a%20couple%20dancing%20under%20string%20lights%20in%20a%20beautiful%20garden%20at%20twilight%2C%20soft%20golden%20hour%20lighting%2C%20cinematic%20wide%20shot%2C%20warm%20romantic%20atmosphere%2C%20film%20grain%20texture%2C%20vintage%20movie%20aesthetic&width=800&height=450&seq=media-romantic-01&orientation=landscape',
    title: '浪漫爱情片精选合集',
    desc: '从经典到当代，收录最受夫妻欢迎的爱情电影',
    duration: '合集 · 36部影片',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20a%20large%20TV%20screen%20displaying%20a%20romantic%20film%2C%20soft%20blankets%20and%20pillows%20on%20a%20comfortable%20sofa%2C%20dim%20warm%20lighting%20from%20fairy%20lights%2C%20popcorn%20and%20wine%20glasses%20on%20coffee%20table%2C%20intimate%20home%20cinema%20vibe&width=800&height=450&seq=media-romantic-02&orientation=landscape',
    title: '情侣影院观影指南',
    desc: '精心策划的二人世界电影片单与观影建议',
    duration: '指南 · 持续更新',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20couple%20walking%20hand%20in%20hand%20along%20a%20sunset%20beach%2C%20silhouette%20against%20golden%20sky%2C%20gentle%20waves%2C%20romantic%20film%20poster%20style%2C%20soft%20dreamy%20atmosphere%2C%20warm%20amber%20and%20rose%20tones&width=800&height=450&seq=media-romantic-03&orientation=landscape',
    title: '夫妻必看影视特辑',
    desc: '精选婚姻家庭题材高分影片，深度解析推荐',
    duration: '特辑 · 24部精选',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            影音空间
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            精彩片段、预告片与专题合集，提前感受影片魅力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden mb-4 aspect-video bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/60 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}